export enum ApplicantLinkTypesEnums {
    SOCIAL_MEDIA_LINKS = 1,
    PERSONAL_LINKS = 10
}